import { Button } from '@1trading/react/components/ui/button';
import { Loading } from '@1trading/react/components/ui/loading';
import { useToast } from '@1trading/react/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useMainstreamCountries } from '@/hooks/queries/use-mainstream-countries';
import { useProfileNotificationMutation } from '@/hooks/queries/use-profile-notification';
import { useUserAttributes } from '@/hooks/queries/use-user-attributes';
import { NotificationKey } from '@/services/api/profile/notification';

export const ForbiddenJurisdictionOpeningNotificationText = () => {
  const { data: countries } = useMainstreamCountries();
  const { data: userAttributes } = useUserAttributes();
  const { jurisdiction } = useParams();
  const { t } = useTranslation();
  const email = userAttributes?.email;

  if (!email || !jurisdiction || !countries?.[jurisdiction]) return null;

  return <span className="block">{t('forbiddenJurisdiction.notifyMe')}</span>;
};
ForbiddenJurisdictionOpeningNotificationText.displayName = 'ForbiddenJurisdictionOpeningNotificationText';

export const ForbiddenJurisdictionOpeningNotificationButton = () => {
  const { data: countries } = useMainstreamCountries();
  const { data: userAttributes } = useUserAttributes();
  const { isPending, isSuccess, mutate } = useProfileNotificationMutation<NotificationKey.JURISDICTION_OPENING>();
  const { jurisdiction } = useParams();
  const { toast } = useToast();
  const { t } = useTranslation();
  const email = userAttributes?.email;

  if (!email || !jurisdiction || !countries?.[jurisdiction]) return null;

  const handleNotifyMe = () => {
    mutate(
      {
        key: NotificationKey.JURISDICTION_OPENING,
        body: {
          email,
          residencyCountry: jurisdiction,
        },
      },
      {
        onError: () => {
          toast({
            description: t('fundamentals.defaultError.message'),
            variant: 'destructive',
          });
        },
        onSuccess: () => {
          toast({
            description: t('forbiddenJurisdiction.notifyMeSuccess.description'),
            title: t('forbiddenJurisdiction.notifyMeSuccess.title'),
          });
        },
      },
    );
  };

  return (
    <Button className="relative" size="lg" variant="primary" disabled={isPending || isSuccess} onClick={handleNotifyMe}>
      <span className={isPending ? 'invisible' : ''}>{t('buttons.notifyMe')}</span>
      {isPending ? <Loading variant="inverted" position="overlay" size="sm" /> : null}
    </Button>
  );
};
ForbiddenJurisdictionOpeningNotificationButton.displayName = 'ForbiddenJurisdictionOpeningNotificationButton';
